import { Pipe, PipeTransform } from '@angular/core';
import {User} from "../../+admin/+users/users.service";

@Pipe({
    name: 'userFilter'
})

export class UserFilter implements PipeTransform {
    transform(users: Array<User>, value:string): Array<User> {
        if(value!=undefined && value!=null && value.length>0){
            let array = users.filter(user=>{
                return this.validSearch(user, value);
            });
            return array;
        }else{
            return users;
        }
    }

    private validSearch(user:User, value:string):boolean{
        if(user.name.toLowerCase().indexOf(value.toLowerCase())>=0)
            return true;
        if(user.username.toLowerCase().indexOf(value.toLowerCase())>=0)
            return true;
        // if(ticket.summary.toLowerCase().indexOf(value.toLowerCase())>=0)
        //     return true;
        // if(ticket.customerData.name.toLowerCase().indexOf(value.toLowerCase())>=0)
        //     return true;
        // if(ticket.customerData.paternalName.toLowerCase().indexOf(value.toLowerCase())>=0)
        //     return true;
        // if(ticket.customerData.maternalName.toLowerCase().indexOf(value.toLowerCase())>=0)
        //     return true;
        return false;
    }
}